import React from "react";
import "./serviceCard.scss";

const ServiceCard = ({ title, image }) => {
  return (
    <div className="service-card">
      <img src={image} alt={title} />
      <div className="overlay">
        <p>{title}</p>
      </div>
    </div>
  );
};

export default ServiceCard;
